// extracted by mini-css-extract-plugin
module.exports = {"moneySize":"styles_moneySize__20o6Q"};